import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asaagriculture',
  templateUrl: './asaagriculture.component.html',
  styleUrls: ['./asaagriculture.component.scss']
})
export class AsaagricultureComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
